import { interval } from 'rxjs';
import { startWith } from 'rxjs/operators';

import request from '@utils/axiosWrapper';
import { PollerMesssage } from '../../push/PushMessage';
import { addStrongNotification } from '../../eventHandler/pushNotification';

/**
 * 轮训间隔：1 小时
 */
const POLLING_INTERVAL = 60 * 60 * 1000;

/**
 * 商家触达文字弹框轮询
 */

const init = () => {
    interval(POLLING_INTERVAL)
        .pipe(startWith(null))
        .subscribe(() => {
            request
                .get<PollerMesssage | null>('/gw/api/push/dialog/poll', {
                    params: {
                        read: 0, // 0 只拉取未读弹窗， 1 拉取所有弹窗
                    },
                })
                .then(message => {
                    if (message) {
                        addStrongNotification({
                            title: message.title,
                            content: message.content,
                            wmPoiId: `${message.wmPoiId}`,
                            href: message.linkUrl,
                            wmEPoiMsgId: `${message.wmEPoiMsgId}`,
                            wmEMsgTraceId: `${message.wmEMsgTraceId}`,
                            templateName: message.templateName,
                            noticeType: '2',
                            dialogType: message.dialogType,
                            ...(message.dialogType === 2
                                ? {
                                      customizeDialogConfig: {
                                          leftBtnType: message.leftBtnType,
                                          leftBtnConfig: {
                                              ...JSON.parse(message.leftBtnConfig || '{}'),
                                              buttonText: message.leftButtonText,
                                          },
                                          rightBtnType: message.rightBtnType,
                                          rightBtnConfig: {
                                              ...JSON.parse(message.rightBtnConfig || '{}'),
                                              buttonText: message.rightButtonText,
                                          },
                                          utmContent: message.utmContent,
                                          buttonCnt: message.buttonCnt,
                                      },
                                  }
                                : {}),
                        });
                    }
                });
        });
};

export default { init };
